import { render, staticRenderFns } from "./index.vue?vue&type=template&id=362d86d3&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingAboutSignup: require('/src/components/landing/landing_about_signup.vue').default,LandingSignup: require('/src/components/landing/landing_signup.vue').default})
